/**
 * Event emitter dedicado para eventos do societario v2 vindos do WebSocket
 * (canal `notification:user:{id}`, tipo `societario_contrato_gerado_v2`).
 *
 * Por que separado do `NotificationContext`:
 * - O context expoe estado da conexao + rota mensagens, mas nao tem pub/sub
 *   generico para varios listeners por tipo.
 * - Este emitter usa `EventTarget` nativo (zero dependencias), permite
 *   N listeners por evento, cleanup correto via removeEventListener.
 *
 * Uso:
 *   // Producao (no provider): emitSocietarioGerado(detail)
 *   // Consumo (em hooks/componentes): const off = onSocietarioGerado(cb); ... off();
 */
export interface ISocietarioGeradoDetail {
  contratoId: number;
  /** Status final: 'gerado' | 'campos_pendentes' | 'falha_geracao' */
  status: string;
  url?: string;
  decisoesIaCount?: number;
  costEstimateUsd?: number;
  error?: string;
  engine?: string;
}

const target = new EventTarget();

export const SOCIETARIO_GERADO_EVENT = 'societario:gerado';

export function emitSocietarioGerado(detail: ISocietarioGeradoDetail): void {
  target.dispatchEvent(new CustomEvent(SOCIETARIO_GERADO_EVENT, { detail }));
}

/**
 * Subscribe — devolve funcao de unsubscribe (idempotente: chamar 2x e seguro).
 */
export function onSocietarioGerado(cb: (detail: ISocietarioGeradoDetail) => void): () => void {
  const handler = (e: Event) => {
    const { detail } = e as CustomEvent<ISocietarioGeradoDetail>;
    cb(detail);
  };
  target.addEventListener(SOCIETARIO_GERADO_EVENT, handler);
  return () => target.removeEventListener(SOCIETARIO_GERADO_EVENT, handler);
}
